import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/settings/confirmation-messages')({
    component: ConfirmationMessagesRedirect,
});

// Confirmation templates now live within the Shift confirmation page.
function ConfirmationMessagesRedirect() {
    return <Navigate to="/settings/shift-confirmations" replace={true} />;
}
